(() => {
  const query = '.shopify-section-group-footer-group .yuanqi-rich-footer__column';
  const media = window.matchMedia('(max-width: 749px)');

  function syncMobileFooter() {
    document.querySelectorAll(query).forEach((column) => {
      if (media.matches) {
        column.removeAttribute('open');
      } else {
        column.setAttribute('open', '');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncMobileFooter, { once: true });
  } else {
    syncMobileFooter();
  }

  media.addEventListener?.('change', syncMobileFooter);
})();
